export type FileRepresenting = Image | Base64File | Base64URLFile;

const thumbSizes = [10, 75, 100, 150, 180, 240, 360, 370, 500, 740, 1000, 1500] as const;
type ThumbSize = (typeof thumbSizes)[number];

export interface Image {
  type?: undefined;
  id: string;
  url: string;
  originalUrl?: string;
  tags: string[];
  order?: number;
  thumbs?: Record<ThumbSize, string>;
  alt?: string;
  altDe?: string;
  altEn?: string;
}

export interface Base64File {
  type: 'base64';
  url: string;
}

export interface Base64URLFile {
  type: 'base64URL';
  url: string;
}

export function imageUrl(image: string | FileRepresenting): string {
  if (typeof image === 'string') {
    return image;
  }
  return image.url;
}

export function bytesFor(file: FileRepresenting | string | null): string | null {
  if (file === null) {
    return null;
  }
  if (typeof file === 'string') {
    return file;
  }
  switch (file.type) {
    case 'base64':
      return file.url;
    case 'base64URL':
      return file.url.split(',')[1];
    default:
      throw 'tried to serialize an Image object';
  }
}

export function processFilesInParams(params: Record<string, unknown>): object {
  const result: Record<string, unknown> = {};
  if (typeof params === 'string') {
    return params;
  }
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (Array.isArray(value)) {
      result[key] = value.map(processFilesInParams);
    } else if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
      const valueKeys = Object.keys(value);
      if (valueKeys.includes('type') && valueKeys.includes('url') && ['base64', 'base64URL'].includes(value['type'])) {
        result[key] = bytesFor(value as FileRepresenting);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        result[key] = processFilesInParams(value as any);
      }
    } else {
      result[key] = value;
    }
  });
  return result;
}
